import { isMocks } from 'common/navUtils';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/theme-trp.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import { ApploadSpan, SpanRegistrarProvider } from '@trp-ta-nitro/otel-react';
import AuthenticatedApp from './components/App';
import AppRoot from './components/App/App';
import AppConfigLoader from './components/App/AppConfigLoader';
import { globalSpanRegistrar, initOpenTelemetry } from './otel';
import store from './state/store';
import './styles/index.scss';

// initialize opentelemetry before as many other things as possible in case instrumentation is happening
initOpenTelemetry(store);

const container = document.getElementById('root');
if (!container) {
  throw new Error('missing root');
}
const root = createRoot(container);

// the entry point to the app...the main things happening here:
//  1. Redux is instantiated, with the above store.
//  2. The app's config is pulled from the server and loaded in to the redux store.
//  3. The app is loaded.
// TODO: <React.StrictMode> has been temporarily disabled because in React18 it bounces the entire
//   application, forcing double-auth and double-fetches...until there's a solution for that, it's
//   simply annoying
//   see: https://github.com/reactwg/react-18/discussions/19
root.render(
  // <React.StrictMode>
  <SpanRegistrarProvider registrar={globalSpanRegistrar()}>
    <ApploadSpan>
      <ReduxProvider store={store}>
        <AppConfigLoader>
          {isMocks() ? <AppRoot /> : <AuthenticatedApp />}
        </AppConfigLoader>
      </ReduxProvider>
    </ApploadSpan>
  </SpanRegistrarProvider>,
  // </React.StrictMode>,
);
